
export class AgrementBureau {
    abu_bureau_id: string;
    abu_id: string;
    abu_montant = null;
    abu_montant_tva: number;

    constructor(init?: Partial<AgrementBureau>) {
        Object.assign(this, init);
        if (init && init.abu_montant && init.abu_bureau_id) {
            this.abu_montant = (+init.abu_montant).toFixed(2);
        } else {
            this.abu_montant = (357143).toFixed(2);
            this.abu_montant_tva = (+this.abu_montant * 3) / 100;
        }
    }
}
